import { Component, EventEmitter, Output } from '@angular/core';
import { FormControl, FormGroup, ReactiveFormsModule, Validators } from '@angular/forms';
import { TranslateModule } from '@ngx-translate/core';
import { ButtonModule } from 'primeng/button';
import { DividerModule } from 'primeng/divider';
import { InputTextModule } from 'primeng/inputtext';
import { ModalHeaderComponent } from 'src/app/shared/modals/components/modal-header/modal-header.component';
import { Modal } from 'src/app/shared/modals/modal';
import { UtilsService } from 'src/app/shared/services/utils.service';
import { GoogleIconComponent } from '../../google-icon/google-icon.component';
import { ApisService, CalendarFor } from 'src/app/shared/services/entities/apis/apis.service';
import { SelectedOrgService } from 'src/app/shared/services/selected-org.service';
import { take } from 'rxjs';
import { CALENDAR_SYNC_CHANNEL } from 'src/app/pages/google-calendar/google-calendar/google-calendar.component';

@Component({
  selector: 'app-google-calendar-connection-modal',
  standalone: true,
  imports: [
    ReactiveFormsModule, TranslateModule, InputTextModule, ButtonModule, DividerModule,
    ModalHeaderComponent, GoogleIconComponent
  ],
  templateUrl: './google-calendar-connection-modal.component.html',
  styleUrl: './google-calendar-connection-modal.component.scss'
})
export class GoogleCalendarConnectionModalComponent extends Modal {

  fetchingAuthUrl = false;
  bc: BroadcastChannel = new BroadcastChannel(CALENDAR_SYNC_CHANNEL);

  @Output() result = new EventEmitter<void>();

  constructor(
    private utilsService: UtilsService,
    private apisService: ApisService,
    private selectedOrgService: SelectedOrgService
  ) {
    super();

    this.bc.onmessage = (e) => {
      this.result.emit();
      this.close();
    };
  }

  form = new FormGroup({
    connectionTitle: new FormControl<string>('', { nonNullable: true, validators: [Validators.required] })
  });

  onSubmit() {
    const orgId = this.selectedOrgService.getCurrentValue();
    if (!orgId) {
      console.error('Missing orgId!');
      return;
    }

    this.utilsService.markFormGroupDirty(this.form);

    if (this.form.invalid) {
      console.error('invalid');
      return;
    }

    this.fetchingAuthUrl = true;

    const tab = window.open('', '_blank');
    tab?.document.write('Loading...');

    this.apisService.getGoogleCalendarAuthUrl({ orgId, for: CalendarFor.LOCATION, title: this.form.controls.connectionTitle.value }).pipe(
      take(1)
    ).subscribe({
      next: (res) => {
        this.fetchingAuthUrl = false;
        if (tab) tab.location.href = res;
      },
      error: (err) => {
        this.fetchingAuthUrl = false;
      }
    })
  }

}
